import { useCreateEventProcedure, useUpdateEventProcedure } from "security-app/hooks/useEventProceduresAPI";
function useFormActions() {
  const { createEventProcedure, creatingEventProcedure } = useCreateEventProcedure();
  const { updateEventProcedure, updatingEventProcedure } = useUpdateEventProcedure();
  const handleSubmit = ({ inValues, eventProcedureId = void 0, cb = void 0 }) => {
    const newProcedure = {
      title: inValues.title,
      description: inValues.description,
      steps: inValues.steps,
      share_request: inValues.share_request
    };
    if (eventProcedureId) {
      updateEventProcedure({ eventProcedureId, eventProcedure: newProcedure }).then(() => cb == null ? void 0 : cb(eventProcedureId));
    } else {
      createEventProcedure(newProcedure).then((createdProcedure) => {
        cb == null ? void 0 : cb(createdProcedure == null ? void 0 : createdProcedure.id);
      });
    }
  };
  return { handleSubmit, saving: creatingEventProcedure || updatingEventProcedure };
}
export default useFormActions;
